import styles from './index.less';
import { FC, useEffect, useState } from 'react';
// import { Helmet, history, useModel } from '@umijs/max';
import { signupWechatActivity } from '@/service/banner';
import { Button, Field, Form, Popup, Toast } from 'react-vant';
import { useModel } from '@umijs/max';

interface BottomSignProps {
  // click: () => void;
  // title: string;
  // list: Array<any>;
  sequenceNbr?: string;
}
interface PopusSignProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: any;
  isOpen: boolean;
  sequenceNbr?: string;
}

const SignPopus: FC<PopusSignProps> = (props) => {
  const { isOpen, onClose, sequenceNbr } = props;
  const { ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation
    }),
  );

  
  const [form] = Form.useForm();

  useEffect(() => {
    if (ownerInformation) {
      form.setFieldsValue({
        ownerName: ownerInformation?.nickName,
        phonenumber: ownerInformation?.phonenumber,
      });
    }
  }, [ownerInformation]);
  
  const [loading, setLoading] = useState(false);
  // setLoading(false)
  function onFinish(values: any): void {
    setLoading(true);
    const data = {
      ...values,
      activityId: sequenceNbr,
      ownerId: ownerInformation?.sequenceNbr,
      signIn: 0,
    };
    signupWechatActivity(data)
      .then((res) => {
        if (res && res.code === 200) {
          Toast.success('报名成功！');
          onClose();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <Popup
        visible={isOpen}
        onClose={onClose}
        closeable
        title="活动报名"
        style={{ width: '80%', height: '50%', background: '#f6f6f6', 'border-radius': '10px' }}
      >
        <div className={styles['register-form']}>
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={{
              phonenumber: '',
              ownerName: '',
            }}
          >
            <Form.Item
              name="ownerName"
              label="用户名"
              rules={[{ required: true, message: '请输入用户名' }]}
            >
              <Field placeholder="请输入" clearable />
            </Form.Item>
            <Form.Item
              name="phonenumber"
              label="手机号"
              rules={[{ required: true, message: '请输入手机号' }]}
            >
              <Field placeholder="请输入" clearable />
            </Form.Item>

            <div className="submit-btn">
              <Button
                round
                block
                type="primary"
                nativeType="submit"
                loading={loading}
                loadingText="提交中..."
              >
                提交
              </Button>
            </div>
          </Form>
        </div>
      </Popup>
    </>
  );
};

const BottomSign: FC<BottomSignProps> = (props) => {
  const { sequenceNbr } = props;
  const [isOpen, setIsOpen] = useState(false);
  const signUp = () => {
    setIsOpen(true);
  };
  return (
    <>
      <div>
        <div className={styles.bottomSign} onClick={signUp}>
          <div className={styles.bottomButton}>报名</div>
        </div>
        <SignPopus
          sequenceNbr={sequenceNbr}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        ></SignPopus>
      </div>
    </>
  );
};

export default BottomSign;
